import { useApi } from 'services';


export const useGetDatajudProcessInfo = () => useApi(
    `/cnj/datajud`,
    'POST',
    {},
    {},
    true
);
